import Web3 from 'web3';
let web3new='undefined';
if (typeof web3 !== 'undefined') {
    // Use Mist/MetaMask's provider
    web3new = new Web3(window.web3.currentProvider);
}
export default web3new;


// WEBPACK FOOTER //
// ./src/web3.js